import { render } from "./edit-question.vue?vue&type=template&id=dc8dd83e"
import script from "./edit-question.vue?vue&type=script&lang=js"
export * from "./edit-question.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__